var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "termsAndPolicyArea",
      class: { isPc: !_vm.isSp, isSp: _vm.isSp },
    },
    [_c("KiyakuAnchor"), _vm._v("及び"), _c("PrivacyPolicyAnchor")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }